import ImageCropper from './components/ImageCropper';

export default ImageCropper;
